import { createFieldToEntityMap } from '../../utils/common';
import { cleanDoubleAndTrailingSpace } from '../../utils/modifiers';
export const getModifiersToCreate = modifierGroups => {
  return modifierGroups == null ? void 0 : modifierGroups.reduce((acc, modifierGroup) => {
    if (modifierGroup.modifiers) {
      acc = acc.concat(modifierGroup.modifiers);
    }
    return acc;
  }, []);
};
export const getModifierGroupKey = modifierGroup => {
  var _modifierGroup$modifi;
  const modifierIds = (_modifierGroup$modifi = modifierGroup.modifiers) == null ? void 0 : _modifierGroup$modifi.map(modifier => modifier.id);
  return `${modifierGroup.name} ${modifierIds == null ? void 0 : modifierIds.toString()}`;
};
export const createKeysToModifierGroupsMap = modifierGroups => {
  return modifierGroups.reduce((acc, modifierGroup) => {
    acc[getModifierGroupKey(modifierGroup)] = modifierGroup;
    return acc;
  }, {});
};
export const attachModifiersToModifierGroups = (modifierGroups, modifiers) => {
  const namesToModifiersMap = createFieldToEntityMap(modifiers, 'name');
  return modifierGroups.map(modifierGroup => ({
    ...modifierGroup,
    modifiers: modifierGroup.modifiers.map(modifier => {
      const modifierName = cleanDoubleAndTrailingSpace(modifier.name);
      if (modifierName) {
        return {
          ...namesToModifiersMap[modifierName],
          additionalChargeInfo: modifier.additionalChargeInfo,
          preSelected: modifier.preSelected
        };
      } else {
        throw Error('Modifier does not have id and/or name');
      }
    })
  }));
};
//# sourceMappingURL=modifierGroups.js.map